import { call, put, takeEvery } from "redux-saga/effects";
import * as types from "./strategiccapacityactionType";
import * as actions from "./strategiccapacityaction";
import * as service from "./strategiccapacityservice";
import { downloadBase64File } from "../../../../utils/fileDownloads";
import Swal from "sweetalert2";
import SweetAlert from "../../../../components/sweetalert/SweetAlert";

function* fetchBlockDemandPlanningReportsDDSaga() {
  try {
    const response = yield call(
      service.getBlockDemandPlanningReportsDDList
    );

    if (response?.success) {
      yield put(
        actions.fetchBlockDemandPlanningReportsDDSuccess(
          response.values?.reportsDDList || []
        )
      );
    } else {
      yield put(
        actions.fetchBlockDemandPlanningReportsDDFailure("No data")
      );
      SweetAlert.error({
        title: 'Error!',
        text: response?.errorMessage || 'Failed to load Reports.',
        showConfirmButton: true
      });
    }
  } catch (error) {
    yield put(
      actions.fetchBlockDemandPlanningReportsDDFailure(
        error.message || "Failed to load reports"
      )
    );
    SweetAlert.error({
      title: 'Error!',
      text: error?.errorMessage || 'Failed to load Reports.',
      showConfirmButton: true
    });
  }
}
// strategic capacity table

function* fetchAllReportsPaginationSaga(action) {
  try {
    const response = yield call(
      service.getAllReportsWithPagination,
      action.payload
    );

    if (response?.success) {
      yield put(
        actions.fetchAllReportsPaginationSuccess({
          data: response.values || [],
          total: response.recordsTotal || 0,
        })
      );
    } else {
      yield put(actions.fetchAllReportsPaginationFailure("No data"));
      SweetAlert.error({
        title: 'Error!',
        text: response?.errorMessage || 'Failed to load reports.',
        showConfirmButton: true
      });
    }
  } catch (error) {
    yield put(
      actions.fetchAllReportsPaginationFailure(
        error.message || "Failed to load reports"
      )
    );
    SweetAlert.error({
      title: 'Error!',
      text: error?.errorMessage || 'Failed to load reports.',
      showConfirmButton: true
    });
  }
}
// strategiccapacitysaga.js
function* deleteCapacityReportSaga(action) {
  try {
    const { id, onSuccess } = action.payload;

    const response = yield call(
      service.deleteCapacityReport,
      id
    );

    if (response?.success) {
      yield put(actions.deleteCapacityReportSuccess());

      yield put(
        actions.fetchAllReportsPaginationRequest({
          PageSize: 100,
          SkipNoOfRecords: 0,
          sortColumn: "BlockPlanningCapacityTableID",
          sortColumnDir: "desc",
        })
      );

      yield call(SweetAlert.success, {
        title: "Success!",
        text: response?.resultMessage || "Report deleted successfully."
      });

      // ✅ Redirect ONLY after alert
      if (onSuccess) {
        yield call(onSuccess);
      }

    } else {
      yield put(actions.deleteCapacityReportFailure("Delete failed"));
      SweetAlert.error({
        title: 'Error!',
        text: response?.errorMessage || 'Failed to delete report.',
        showConfirmButton: true
      });
    }
  } catch (error) {
    yield put(
      actions.deleteCapacityReportFailure(
        error.message || "Delete failed"
      )
    );
    SweetAlert.error({
      title: 'Error!',
      text: error.message || 'An error occurred while deleting the report.',
      showConfirmButton: true
    });
  }
}

function* exportCapacityReportsSaga(action) {
  try {
    let exportAPIURL, payload, moduleName, fileName;

    if (action.payload?.exportAPIURL) {
      exportAPIURL = action.payload.exportAPIURL;
      payload = action.payload.payload;
      moduleName = action.payload.moduleName || "Strategic Capacity Planner";
      fileName = action.payload.fileName;
    } else {
      payload = action.payload;
      moduleName = "Strategic Capacity Planner";
      fileName = action.payload.fileName;
    }

    const response = exportAPIURL
      ? yield call(service.exportReportsData, exportAPIURL, payload)
      : yield call(service.exportReportsData, payload);

    const base64Data = response?.values || response;

    yield call(
      downloadBase64File,
      base64Data,
      moduleName,
      fileName
    );

    yield put(actions.exportCapacityReportSuccess(response));
  } catch (error) {
    console.error("Export error:", error);
    yield put(
      actions.exportCapacityReportFailure("Export failed")
    );
    SweetAlert.error({
      title: 'Error!',
      text: error.message || 'An error occurred while exporting reports.',
      showConfirmButton: true
    });
  }
}
function* fetchBlockCapacityTableSaga(action) {
  try {
    const response = yield call(
      service.getBlockCapacityTableById,
      action.payload
    );

    if (response?.success) {
      yield put(
        actions.fetchBlockCapacityTableSuccess({
          radTab: action.payload.radTab,
          data:
            action.payload.radTab === "Active"
              ? response.values?.listCapacityActiveRad
              : action.payload.radTab === "Pending"
                ? response.values?.listCapacityPendingRad
                : response.values?.listCapacityOffboardingRad,
        })
      );
    } else {
      yield put(
        actions.fetchBlockCapacityTableFailure({
          radTab: action.payload.radTab,
        })
      );
      SweetAlert.error({
        title: 'Error!',
        text: response?.errorMessage || 'Failed to fetch block capacity table.',
        showConfirmButton: true
      });
    }
  } catch (error) {
    yield put(
      actions.fetchBlockCapacityTableFailure({
        radTab: action.payload.radTab,
      })
    );
    SweetAlert.error({
      title: 'Error!',
      text: error.message || 'An error occurred while fetching block capacity table.',
      showConfirmButton: true
    });
  }
}

function* fetchCapacityTableReportSaga(action) {
  try {
    const response = yield call(
      service.getBlockPlanningCapacityTableReport,
      action.payload
    );

    if (response?.success) {
      yield put(
        actions.fetchCapacityTableReportSuccess({
          data: response.values || {},
          blockCapacityTableId: response.values?.BlockPlanningCapacityTableID,
        })
      );
    } else {
      yield put(actions.fetchCapacityTableReportFailure("No data"));
      SweetAlert.error({
        title: 'Error!',
        text: response?.errorMessage || 'Failed to load capacity table report.',
        showConfirmButton: true
      });
    }
  } catch (error) {
    yield put(
      actions.fetchCapacityTableReportFailure(
        error.message || "Failed to load capacity table report"
      )
    );
    SweetAlert.error({
      title: 'Error!',
      text: error?.errorMessage || 'Failed to load capacity table report.',
      showConfirmButton: true
    });
  }
}

// strategiccapacitysaga.js
function* fetchReportNoteSaga(action) {
  try {
    const response = yield call(
      service.getBlockPlanningReportNote,
      action.payload
    );

    if (response?.success) {
      yield put(
        actions.fetchReportNoteSuccess(response.values)
      );
    } else {
      yield put(actions.fetchReportNoteFailure("No notes"));
      SweetAlert.error({
        title: 'Error!',
        text: response?.errorMessage || 'Failed to fetch report note.',
        showConfirmButton: true
      });
    }
  } catch (error) {
    yield put(
      actions.fetchReportNoteFailure(
        error.message || "Failed to fetch note"
      )
    );
    SweetAlert.error({
      title: 'Error!',
      text: error?.errorMessage || 'Failed to fetch report note.',
      showConfirmButton: true
    });
  }
}

function* updateReportNoteSaga(action) {
  try {
    const response = yield call(
      service.updateBlockPlanningReportNote,
      action.payload
    );

    if (response?.success) {
      yield put(actions.updateReportNoteSuccess());

      // 🔁 Refresh note after update
      yield put(
        actions.fetchReportNoteRequest({
          ReportTypeId: action.payload.ReportTypeId,
          ReportId: action.payload.ReportId,
        })
      );
      // Show success message
      SweetAlert.success({
        title: 'Success!',
        text: 'Notes updated successfully.',
        timer: 2000,
        showConfirmButton: true
      });
    } else {
      yield put(actions.updateReportNoteFailure("Update failed"));
      SweetAlert.error({
        title: 'Error!',
        text: response?.errorMessage || 'Failed to update report note.',
        showConfirmButton: true
      });
    }
  } catch (error) {
    yield put(
      actions.updateReportNoteFailure(
        error.message || "Update failed"
      )
    );
    SweetAlert.error({
      title: 'Error!',
      text: error?.errorMessage || 'Failed to update report note.',
      showConfirmButton: true
    });
  }
}
// strategiccapacitysaga.js
function* fetchCapacityDailyViewSaga(action) {
  try {
    const response = yield call(
      service.getCapacityTableGridDailyViewDataWithPagination,
      action.payload
    );

    if (response?.success) {
      yield put(
        actions.fetchCapacityDailyViewSuccess({
          data: response.values?.lstBlockCapacityTable || [],
          total: response.recordsTotal || 0
        })
      );
    } else {
      yield put(
        actions.fetchCapacityDailyViewFailure("No data")
      );
      SweetAlert.error({
        title: 'Error!',
        text: response?.errorMessage || 'Failed to fetch block capacity table.',
        showConfirmButton: true
      });
    }
  } catch (error) {
    yield put(
      actions.fetchCapacityDailyViewFailure(
        error.message || "Failed to load daily view"
      )
    );
    SweetAlert.error({
      title: 'Error!',
      text: error?.errorMessage || 'Failed to fetch block capacity table.',
      showConfirmButton: true
    });
  }
}
function* fetchCapacityFilterDDSaga() {
  try {
    const response = yield call(
      service.getBlockCapacityFilterDDModel
    );

    if (response?.success) {
      yield put(
        actions.fetchCapacityFilterDDSuccess(response)
      );
    } else {
      yield put(
        actions.fetchCapacityFilterDDFailure("No filter data")
      );
      SweetAlert.error({
        title: 'Error!',
        text: response?.errorMessage || 'Failed to load capacity filter data.',
        showConfirmButton: true
      });
    }
  } catch (error) {
    yield put(
      actions.fetchCapacityFilterDDFailure(
        error.message || "Failed to load capacity filters"
      )
    );
    SweetAlert.error({
      title: 'Error!',
      text: error?.errorMessage || 'Failed to load capacity filter data.',
      showConfirmButton: true
    });
  }
}

function* fetchWorklistByRPCESaga(action) {
  try {
    const { rpceIds } = action.payload;

    const response = yield call(service.getWorkListByRPCEIds, rpceIds);

    if (response?.success) {
      yield put(
        actions.fetchWorklistByRPCESuccess(
          response?.values?.WorkListDropdownItems || []
        )
      );
    } else {
      yield put(actions.fetchWorklistByRPCEFailure("No data found"));
      SweetAlert.error({
        title: 'Error!',
        text: response?.errorMessage || 'Failed to fetch Worklist Provider Facilities.',
        showConfirmButton: true
      });
    }
  } catch (error) {
    console.error("Worklist Provider Facilities Fetch Error:", error);
    yield put(actions.fetchWorklistByRPCEFailure("Failed to fetch Worklist Provider Facilities"));
    SweetAlert.error({
      title: 'Error!',
      text: error?.errorMessage || 'Failed to load Worklist Provider Facilities.',
      showConfirmButton: true
    });
  }
}
function* fetchOnboardingSiteLegendSaga() {
  try {
    const response = yield call(
      service.getOnboardingSiteDemandPlannerLegend
    );
    yield put(actions.fetchOnboardingSiteLegendSuccess(response));
  } catch (error) {
    yield put(
      actions.fetchOnboardingSiteLegendFailure(error.message)
    );
    SweetAlert.error({
      title: 'Error!',
      text: error?.errorMessage || 'Failed to fetch Onboarding Site Legend.',
      showConfirmButton: true
    });
  }
}
function* fetchCapacityQuarterlyViewSaga(action) {
  try {
    const response = yield call(
      service.GetCapacityTableGridQuarterlyViewDataWithPagination,
      action.payload
    );

    yield put(
      actions.fetchCapacityQuarterlyViewSuccess({
        data: response?.values?.lstBlockCapacityTable || [],
        total: response.recordsTotal || 0
      })
    );
  } catch (error) {
    yield put(
      actions.fetchCapacityQuarterlyViewFailure(error)
    );
    SweetAlert.error({
      title: 'Error!',
      text: error?.errorMessage || 'Failed to fetch Capacity Quarterly View.',
      showConfirmButton: true
    });
  }
}
// strategiccapacitysaga.js
// function* draftCapacityTableSaga(action) {
//   try {
//     const response = yield call(
//       service.draftBlockCapacityPlanningTableReport,
//       action.payload
//     );

//     if (response?.success) {
//       yield put({ type: types.DRAFT_CAPACITY_TABLE_SUCCESS });

//       SweetAlert.success({
//         title: "Success!",
//         text: response?.resultMessage || "Report saved as draft successfully."
//       });
//     } else {
//       yield put({ type: types.DRAFT_CAPACITY_TABLE_FAILURE });
//       SweetAlert.error({
//         title: 'Error!',
//         text: response?.errorMessage || 'Failed to draft capacity table report.',
//         showConfirmButton: true
//       });
//     }
//   } catch (error) {
//     yield put({ type: types.DRAFT_CAPACITY_TABLE_FAILURE });
//     SweetAlert.error({
//       title: 'Error!',
//       text: error?.errorMessage || 'Failed to draft capacity table report.',
//       showConfirmButton: true
//     });
//   }
// }

function* draftCapacityTableSaga(action) {
  try {
    const response = yield call(
      service.draftBlockCapacityPlanningTableReport,
      action.payload
    );

    if (response && response.success) {
      yield put(actions.draftCapacityTableSuccess(response));

      // Show success message
      SweetAlert.success({
        title: 'Success!',
        text: response.resultMessage,
        showConfirmButton: true
      });
    } else {
      yield put(actions.draftCapacityTableFailure(response?.errorMessage));

      // Show error message
      SweetAlert.error({
        title: 'Error!',
        text: response?.errorMessage,
        showConfirmButton: true
      });
    }
  } catch (error) {
    yield put(actions.draftCapacityTableFailure(error.message || 'An error occurred'));

    // Show error message
    SweetAlert.error({
      title: 'Error!',
      text: error.message || 'An error occurred while drafting capacity table report',
      showConfirmButton: true
    });
  }
}

function* publishCapacityTableSaga(action) {
  try {
    const response = yield call(
      service.publishBlockCapacityPlanningTableReport,
      action.payload
    );

    if (response?.success) {
      yield put({ type: types.PUBLISH_CAPACITY_TABLE_SUCCESS });

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Report published successfully."
      });
    } else {
      yield put({ type: types.PUBLISH_CAPACITY_TABLE_FAILURE });
      SweetAlert.error({
        title: 'Error!',
        text: response?.errorMessage || 'Failed to publish capacity table report.',
        showConfirmButton: true
      });
    }
  } catch (error) {
    yield put({ type: types.PUBLISH_CAPACITY_TABLE_FAILURE });
    SweetAlert.error({
      title: 'Error!',
      text: error?.errorMessage || 'Failed to publish capacity table report.',
      showConfirmButton: true
    });
  }
}

// strategiccapacity cascading WeekQuarterByMonthYear
function* fetchWeekQuarterByMonthYearSaga(action) {
  try {
    const { fromMonthYear, toMonthYear } = action.payload;
    
    const response = yield call(
      service.getWeekQuarterByMonthYear,
      fromMonthYear,
      toMonthYear
    );

    if (response?.success) {
      yield put(
        actions.fetchWeekQuarterByMonthYearSuccess({
          weeks: response?.values?.Weeks || [],
          quarters: response?.values?.Quarters || [],
        })
      );
    } else {
      yield put(
        actions.fetchWeekQuarterByMonthYearFailure(
          response?.errorMessage || "Failed to fetch week/quarter data"
        )
      );
      SweetAlert.error({
        title: 'Error!',
        text: response?.errorMessage || 'Failed to fetch week/quarter data.',
        showConfirmButton: true
      });
    }
  } catch (error) {
    yield put(
      actions.fetchWeekQuarterByMonthYearFailure(
        error.message || "Failed to fetch week/quarter data"
      )
    );
    SweetAlert.error({
      title: 'Error!',
      text: error?.errorMessage || 'Failed to fetch week/quarter data.',
      showConfirmButton: true
    });
  }
}



/* ======================================================
   Watcher
   ====================================================== */
export default function* watchStrategicCapacity() {
  yield takeEvery(types.FETCH_BLOCK_DEMAND_PLANNING_REPORTS_DD_REQUEST, fetchBlockDemandPlanningReportsDDSaga);
  yield takeEvery(types.FETCH_ALL_REPORTS_PAGINATION_REQUEST, fetchAllReportsPaginationSaga);
  yield takeEvery(types.DELETE_STRATEGIC_CAPACITY_REPORT_REQUEST, deleteCapacityReportSaga);
  yield takeEvery(types.EXPORT_CAPACITY_REPORT_REQUEST, exportCapacityReportsSaga);
  yield takeEvery(types.FETCH_BLOCK_CAPACITY_TABLE_REQUEST, fetchBlockCapacityTableSaga);
  yield takeEvery(types.FETCH_CAPACITY_TABLE_REPORT_REQUEST, fetchCapacityTableReportSaga);
  yield takeEvery(types.FETCH_REPORT_NOTE_REQUEST, fetchReportNoteSaga);
  yield takeEvery(types.UPDATE_REPORT_NOTE_REQUEST, updateReportNoteSaga);
  yield takeEvery(types.FETCH_CAPACITY_DAILY_VIEW_REQUEST, fetchCapacityDailyViewSaga);
  yield takeEvery(types.FETCH_CAPACITY_FILTER_DD_REQUEST, fetchCapacityFilterDDSaga);
  yield takeEvery(types.FETCH_WORKLIST_BY_RPCE_REQUEST, fetchWorklistByRPCESaga);
  yield takeEvery(types.FETCH_ONBOARDING_SITE_LEGEND_REQUEST, fetchOnboardingSiteLegendSaga);
  yield takeEvery(types.FETCH_CAPACITY_QUARTERLY_VIEW_REQUEST, fetchCapacityQuarterlyViewSaga);
  yield takeEvery(types.DRAFT_CAPACITY_TABLE_REQUEST, draftCapacityTableSaga);
  yield takeEvery(types.PUBLISH_CAPACITY_TABLE_REQUEST, publishCapacityTableSaga);
  yield takeEvery(types.FETCH_WEEK_QUARTER_BY_MONTH_YEAR_REQUEST, fetchWeekQuarterByMonthYearSaga);

}

